/*
 * @Author: liyu
 * @Date: 2022-05-17 10:17:50
 * @LastEditTime: 2022-06-15 18:24:47
 * @Description: file content
 * @FilePath: /sensors-www/src/components/ManageUnit/Card/index.tsx
 */
import React, { CSSProperties } from 'react'
import classnames from 'classnames'

import * as styles from './index.module.less'

export interface CardProps {
  cover?: string
  title?: string
  coverWidth?: number
  coverHeight?: number
  iconClassName?: string
  titleColor?: string
  desc?: string
  className?: string
  style?: CSSProperties
  isHeight?: boolean
}
const Card: React.FC<CardProps> = (props) => {
  const {
    className,
    cover,
    coverWidth,
    coverHeight,
    title,
    titleColor = '#1F2D3D',
    desc,
    style,
    isHeight = true,
    iconClassName,
  } = props

  const cnames = classnames(styles.Card, className)
  return (
    <div style={style} className={cnames}>
      <img
        style={{
          width: coverWidth,
          height: coverHeight,
        }}
        src={cover}
        alt=""
        className={classnames('block mx-auto w-auto', iconClassName)}
      />
      <div className="text-center mt-[20px]">
        <h3
          style={{
            color: titleColor,
          }}
          className="text-[20px] leading-[30px] line-clamp-1 font-medium"
        >
          {title}
        </h3>
        <p
          className={classnames('text-[14px] mt-[10px] leading-[2] font-light line-clamp-3', { 'h-[84px]': isHeight })}
        >
          {desc}
        </p>
      </div>
    </div>
  )
}

export default Card
